import { useEffect, useState } from "react";
import MainLayout from "../layouts/MainLayout";
import PageTitle from '../components/UtilityHelpers/PageTitle';

import { useAuth } from "../hooks/useAuth";
import { useLoader } from "../hooks/useLoader";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useGetRequestByID } from "../hooks/Request/useGetRequestByID";


const WhichRequestViewForCommentsPage = () => {
    const [searchParams] = useSearchParams();
    const loader = useLoader();
    const auth = useAuth();
    const navigate = useNavigate();

    const requestIDFromParam = searchParams.get("id");
    const request_id_from_param: number = requestIDFromParam !== null && requestIDFromParam !== undefined ? parseInt(requestIDFromParam) : 0;

    const { fetchRequestsByID } = useGetRequestByID(request_id_from_param);
    
    useEffect(() => {

        const role = auth?.roles?.find(role => ["500", "400", "300", "200", "100"].includes(role));

        const loadData = async () => {
            try {

                loader?.setIsLoading(true);

                const requestData = await fetchRequestsByID();
                const currentRequestStatus = requestData[0].status;
                
                if (auth?.roles?.find(role => ["500"]?.includes(role))) {
                    if (["New", "Waitlisted",  "Approved", "Declined", "Ordered", "Purchased", "Delivered"].includes(currentRequestStatus)) {
                        navigate("/admin/view-request?id=" + request_id_from_param)
                    } 
                    return <></>
                }                    

                if (auth?.roles?.find(role => ["300"]?.includes(role))) {
                    if (["New", "Waitlisted"].includes(currentRequestStatus)) {
                        navigate("/approver/view-request?id=" + request_id_from_param)
                    }
                    if (["Approved", "Declined", "Ordered", "Purchased", "Delivered"].includes(currentRequestStatus)) {
                        navigate("/request/view-request-details?id=" + request_id_from_param)
                    }
                    return <></>
                }                

                if (auth?.roles?.find(role => ["100"]?.includes(role))) {
                    if (["New", "Waitlisted"].includes(currentRequestStatus)) {
                        navigate("/request/request-details?id=" + request_id_from_param)
                    }
                    if (["Approved", "Declined", "Ordered", "Purchased", "Delivered"].includes(currentRequestStatus)) {
                        navigate("/request/view-request-details?id=" + request_id_from_param)
                    }
                    return <></>
                }
                
            } catch (error) {
                loader?.setIsLoading(false);
                navigate('/login');
                console.error(error);
            }
        }

        loadData();
        
    }, []);
    return (
        <>           
        </>
    )
}

export default WhichRequestViewForCommentsPage;